import { render, staticRenderFns } from "./ThongTinPhong.vue?vue&type=template&id=306aceaa"
import script from "./ThongTinPhong.vue?vue&type=script&lang=js"
export * from "./ThongTinPhong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports